import React from 'react';
import { Link } from 'react-router-dom'; // 1. Importante: Importar o Link
import './styles.css';

const Navbar = () => {

    return (
        <header>
            <nav>
                {/* O Logo também deve ser um Link para não recarregar a página */}
                <Link to='/' id='logo'>
                    <img src="/logo.svg" alt="Logo"/>
                    <p id='logo-title'>Laboratório de Inovação em Gestão e Computação Aplicada</p>  
                </Link>
                
                <div id='nav-options'>
                    {/* 2. Troque todos os 'a href' por 'Link to' */}
                    <Link to='/sobre'>Sobre</Link>
                    <Link to='/linhas-de-pesquisa'>Linhas de Pesquisa</Link>
                    <Link to='/Projects'>Projetos</Link>
                    <Link to='/pessoas'>Pessoas</Link>
                    {/* <Link to='/Dashboard'>Dashboard</Link> */}
                    <Link to='/formacoes'>Formações</Link>
                    
                    {/* Links de âncora (como #footer) podem continuar como 'a' ou usar uma função de scroll */}
                    <a href='#footer-content'>Contato</a>
                </div>
            </nav>
        </header>
    )
}

export default Navbar;